import React from 'react';
import AddLeague from '../../components/leagues/new-league';

const NewLeagueContainer = () => {
    return <AddLeague />;
};

export default NewLeagueContainer;
